import DownloadUser from './DownloadUser';
import AdminLayout from './UserLayout';
import OperatorAccount from './OperatorAccount';

const module = {
    routeProps: {
        path: 'User',
        component: AdminLayout
    },
    name : 'User',
    label:'User',
    submodules: [ DownloadUser, OperatorAccount],
    showOnHeader: true
}
export default module;